export default "__VITE_ASSET__Bl0lsZ2Z__"